import * as React from 'react';

export function RocketIcon(props) {
  return (
    <svg
      width={18}
      height={18}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M9 11.25L6.75 9M9 11.25a16.768 16.768 0 003-1.5m-3 1.5V15s2.273-.412 3-1.5c.81-1.215 0-3.75 0-3.75M6.75 9a16.5 16.5 0 011.5-2.962A9.66 9.66 0 0116.5 1.5c0 2.04-.585 5.625-4.5 8.25M6.75 9H3s.413-2.272 1.5-3c1.215-.81 3.75 0 3.75 0m-4.875 6.375c-1.125.945-1.5 3.75-1.5 3.75s2.805-.375 3.75-1.5c.532-.63.525-1.597-.067-2.182a1.635 1.635 0 00-2.183-.068z"
        stroke="url(#prefix__paint0_linear_476_23236)"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <linearGradient
          id="prefix__paint0_linear_476_23236"
          x1={2}
          y1={3.5}
          x2={14}
          y2={16}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#6C47FF" />
          <stop offset={1} stopColor="#17CCFC" />
        </linearGradient>
      </defs>
    </svg>
  );
}
